        <div class="setup-component-aging">
             <div class="row">
                <div class="col-md-12">
                    <div class="margin-top-20 text-center">
                        <h4>Indicate the inflation rate by which your {{ 'components' | terminology | async }} will be aged</h4>
                    </div>
                </div>
            </div>
            <div class="aging-details">
                <div>
                    <form [formGroup]="formGroup">

                        <div class="row">
                            <div class="col-md-5 col-sm-12">
                                <label>Inflation Rate</label>
                            </div>
                            <div class="col-md-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="fa fa-percent" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control" formControlName="inflationRate" name="inflationRate" #inflationRate
                                           placeholder="Inflation %" maxlength="5" required spAutoNumeric />
                                </div>

                                <sp-field-error [controlName]="'Inflation Rate'" [control]="inflationRate"></sp-field-error>
                            </div>
                            <div class="col-md-4">
                                <div class="font-size-small font-light text-muted padding-top-10">{{ 'Components' | terminology | async }} with custom inflation values will continue to use their specific inflation rate.</div>
                            </div>
                        </div>

                        <div class="row margin-top-70">
                            <div class="col-md-5 col-sm-12">
                                <label>Would you like to update your {{ 'components' | terminology | async }} information source?</label>
                            </div>
                            <div class="col-md-7">
                                <div>
                                    <label class="btn-radio-container"><input type="radio" [value]="true" formControlName="informationSourceYesNo" #informationSourceYes><span></span> Yes</label>
                                    <label class="btn-radio-container"><input type="radio" [value]="false" formControlName="informationSourceYesNo"><span></span> No</label>
                                </div>
                                <div *ngIf="informationSourceYes.checked">
                                    <div class="margin-top-10">
                                            <select class="sp-select form-control" name="informationSourceId" formControlName="informationSourceId" id="informationSourceId">
                                                <option *ngFor="let item of informationSources" [ngValue]="item.informationSourceId">{{ item?.name }}</option>
                                            </select>
                                            <sp-field-error [controlName]="'Source of ' + (('Component' | terminology | async) || 'Component') + ' Information'" [control]="formGroup.controls['informationSourceId']"></sp-field-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- <div class="text-center margin-top-50">
                <button class="btn btn-success" (click)="onNextClicked()">Create copy & start planning</button>
            </div> -->
        </div>
